export enum OrgGuardRequiredStatus {
  ORG_EXISTS = "ORG_EXISTS",
  NO_ORG = "NO_ORG"
}
